'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');
var format = require('date-fns/format');
var parseISO = require('date-fns/parseISO');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var format__default = /*#__PURE__*/_interopDefaultLegacy(format);
var parseISO__default = /*#__PURE__*/_interopDefaultLegacy(parseISO);

var _templateObject;
var Wrapper = bumbag.styled(bumbag.Box)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  align-items: center;\n  display: flex;\n  height: 44px;\n"])));

var RefundReferenceList = function RefundReferenceList(_ref) {
  var refunds = _ref.refunds,
      transactionId = _ref.transactionId;
  return refunds.map(function (refund) {
    return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
      key: refund.paymentId
    }, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement(bumbag.Link, {
      href: "/account/transactions/view/?id=" + transactionId + "&paymentId=" + refund.paymentId,
      tabIndex: 0
    }, refund.amountString, " was refunded"), ' ', "on ", format__default["default"](parseISO__default["default"](refund.requested), 'dd/MM/yyyy')));
  });
};

RefundReferenceList.defaultProps = {};

exports["default"] = RefundReferenceList;
